import { createSagaAction } from '../../shared/sagas'
import { createReducer } from '../../shared/reducers'

// Constants
export const constants = {
  GET_ALL_HELP: createSagaAction('GET_ALL_HELP'),
  HELP_REFRESH: createSagaAction('HELP_REFRESH'),
  CREATE_HELP: createSagaAction('CREATE_HELP'),
  EDIT_HELP: createSagaAction('EDIT_HELP'),
  DELETE_HELP: createSagaAction('DELETE_HELP'),

  //Attachment
  UPLOAD_HELP_ATTACHMENT: createSagaAction('UPLOAD_HELP_ATTACHMENT'),
  GET_HELP_ATTACHMENTS: createSagaAction('GET_HELP_ATTACHMENTS'),
  UPDATE_HELP_ATTACHMENT_DESCRIPTION: createSagaAction('UPDATE_HELP_ATTACHMENT_DESCRIPTION'),
  DELETE_HELP_ATTACHMENT: createSagaAction('DELETE_HELP_ATTACHMENT')
}

// Action Creators
export const actions = {
  helpRefresh: () => ({ type: constants.HELP_REFRESH.ACTION }),

  getAllHelp: () => ({
    type: constants.GET_ALL_HELP.ACTION
  }),
  createHelp: ({ content, userId }) => ({
    type: constants.CREATE_HELP.ACTION,
    content,
    userId
  }),
  editHelp: ({ content, helpId }) => ({
    type: constants.EDIT_HELP.ACTION,
    content,
    helpId
  }),
  deleteHelp: ({ helpId }) => ({
    type: constants.DELETE_HELP.ACTION,
    helpId
  }),
  // Help Attachment actions
  uploadHelpAttachment: ({ formData, helpId }) => ({
    type: constants.UPLOAD_HELP_ATTACHMENT.ACTION,
    formData,
    helpId
  }),

  getHelpAttachments: ({ helpId }) => ({
    type: constants.GET_HELP_ATTACHMENTS.ACTION,
    helpId
  }),

  updateHelpAttachmentDescription: ({ attachmentId, helpId, description, userId }) => ({
    type: constants.UPLOAD_HELP_ATTACHMENT.ACTION,
    attachmentId,
    helpId,
    description,
    userId
  }),

  deleteHelpAttachment: ({ attachmentId, helpId }) => ({
    type: constants.DELETE_HELP_ATTACHMENT.ACTION,
    attachmentId,
    helpId
  })
}

// Reducer
const initialState = [
  {
    name: ''
  }
]

export default createReducer(initialState, (state, { type, payload }) => {
  switch (type) {
    default:
      return state
    case constants.HELP_REFRESH.SUCCESS:
      return { ...state, payload }
    case constants.GET_ALL_HELP.ACTION:
      return { ...state, error: null, loading: true }
    case constants.GET_ALL_HELP.SUCCESS:
      return {
        ...state,
        allHelp: payload
      }
    case constants.CREATE_HELP.ACTION:
      return { ...state, loading: true }
    case constants.CREATE_HELP.SUCCESS:
      return {
        ...state,
        loading: false,
        msg: 'Help created!'
      }
    case constants.CREATE_HELP.FAILED:
      return {
        ...state,
        loading: false,
        msg: 'Problems creating help, please try again.'
      }
    case constants.EDIT_HELP.SUCCESS:
      return {
        ...state,
        loading: false,
        msg: 'Help edited!'
      }
    case constants.EDIT_HELP.FAILED:
      return {
        ...state,
        loading: false,
        msg: 'Problems editing help, please try again.'
      }
    case constants.DELETE_HELP.SUCCESS:
      return {
        ...state,
        loading: false,
        msg: 'Help deleted!'
      }
    case constants.DELETE_HELP.FAILED:
      return {
        ...state,
        loading: false,
        msg: 'Problems deleting help, please try again.'
      }
    //Attachments
    case constants.UPLOAD_HELP_ATTACHMENT.ACTION:
      return { ...state, error: null, uploadingHelpAttachment: true }
    case constants.UPLOAD_HELP_ATTACHMENT.SUCCESS:
      return {
        ...state,
        uploadingHelpAttachment: false
      }

    case constants.GET_HELP_ATTACHMENTS.ACTION:
      return { ...state, error: null, loadingHelpAttachments: true }
    case constants.GET_HELP_ATTACHMENTS.SUCCESS:
      return {
        ...state,
        helpHelpAttachments: payload,
        loadingHelpAttachments: false
      }

    case constants.UPDATE_HELP_ATTACHMENT_DESCRIPTION.SUCCESS:
      return {
        ...state
      }

    case constants.DELETE_HELP_ATTACHMENT.ACTION:
      return { ...state, error: null, deletingHelpAttachment: true }
    case constants.DELETE_HELP_ATTACHMENT.SUCCESS:
      return {
        ...state,
        deletingHelpAttachment: false
      }
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/helpActions.js